import React from 'react'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

const useStyles = makeStyles(
  theme => ({
    root: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      zIndex: theme.zIndex.searchShadow,
      backgroundColor: 'rgba(252,251,250,0.5)',
    },
    loaderContainer: {},
    preloaderText: {},
    transparent: {},
  }),
  { name: 'Shadow' },
)

interface ShadowProps {
  readonly className?: string
  readonly open?: Boolean
}

const Shadow = ({ open, className }: ShadowProps) => {
  const classes = useStyles()

  if (!open) {
    return null
  }

  return <div className={classNames(className, classes.root)} />
}

export default Shadow
